// src/components/NoLicense.js
// Shown when a user navigates to a module that is not licensed.
// Two source-paths: per-entity localStorage-licens (legacy) eller
// backend-utfärdad .lic-fil (LIC-106). Båda resulterar i samma vy med
// kontextuell hint om var man skapar/förnyar licens.

import React from 'react';
import { FaLock, FaUpload } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import { t, useLanguage } from '../useTranslations';
import { useLicense } from '../hooks/useLicense';
import usePermission from '../hooks/usePermission';
import './NoLicense.css';

const NoLicense = () => {
  useLanguage();
  const navigate = useNavigate();
  const { state, customer } = useLicense();
  const { canAdmin } = usePermission('Admin');

  const isBackendEnforced = state === 'valid' || state === 'expired_grace' || state === 'expired_locked';

  return (
    <div className="no-license-container">
      <div className="no-license-card">
        <FaLock className="no-license-icon" />
        <h2 className="no-license-heading">{t('modules.administration.licenses.noLicenseHeading')}</h2>
        <p className="no-license-message">
          {isBackendEnforced
            ? t('modules.administration.licenses.noLicenseBackendMessage', { customer: customer || t('modules.administration.licenses.unknownCustomer') })
            : t('modules.administration.licenses.noLicenseMessage')}
        </p>
        {canAdmin && (
          <button
            type="button"
            className="no-license-action"
            onClick={() => navigate('/admin?tab=usersAccess&tool=licenseUpload')}
          >
            <FaUpload /> {t('modules.administration.licenses.openLicenseUpload')}
          </button>
        )}
      </div>
    </div>
  );
};

export default NoLicense;
